"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var Styled = __importStar(require("./TooltipStyles"));
var styled_components_1 = require("styled-components");
function Tooltip(_a) {
    var children = _a.children, content = _a.content, _b = _a.animation, animation = _b === void 0 ? "move" : _b, _c = _a.align, align = _c === void 0 ? "bottom" : _c, _d = _a.shift, shift = _d === void 0 ? "0" : _d, _e = _a.notRelative, notRelative = _e === void 0 ? false : _e, _f = _a.zIndex, zIndex = _f === void 0 ? true : _f, theme = _a.theme, props = __rest(_a, ["children", "content", "animation", "align", "shift", "notRelative", "zIndex", "theme"]);
    var _g = React.useState(false), vis = _g[0], setVis = _g[1];
    return (React.createElement(Styled.TooltipContainer, { notRelative: notRelative, zIndex: zIndex, onMouseEnter: function () { return setVis(true); }, onMouseLeave: function () { return setVis(false); } },
        children,
        React.createElement(Styled.TooltipContent, __assign({ notRelative: notRelative, visible: vis, animation: animation, align: align, shift: shift, isDarkTheme: (theme === null || theme === void 0 ? void 0 : theme.themeName) === "dark" }, props), content)));
}
exports.default = (0, styled_components_1.withTheme)(Tooltip);
